//@ts-nocheck

const profileCards = () => {
  const texts = document.querySelectorAll(".js-profile-cards-text");
  if (texts.length == 0) {
    return;
  }
  const buttons = document.querySelectorAll(".js-profile-cards-btn");
  const convertedTexts;
  const fullTexts;

  console.log(texts);

  const convertText = () => {
    convertedTexts = Array.from(texts).map((text) => {
      let content = text.innerText;
      content = truncate(content, 200);
      return content;
    });
  };

  const keepFullTexts = () => {
    fullTexts = Array.from(texts).map((item) => {
      return item.innerText;
    });
  };

  const replaceText = () => {
    texts.forEach((text, index) => {
      text.innerHTML = "<p>" + convertedTexts[index] + "</p>";
    });
  };

  const resizeContainer = (container) => {
    let height = container.querySelector("p").getBoundingClientRect().height;
    container.style.maxHeight = height + "px";
  };

  const resizeContainers = () => {
    texts.forEach((text) => {
      if (!text.classList.contains("active")) {
        resizeContainer(text);
      }
    });
  };

  function truncate(str, n) {
    if (str.length <= n) {
      return str;
    }
    const subString = str.slice(0, n - 1);
    return subString.slice(0, subString.lastIndexOf(" ")) + "...";
  }
  keepFullTexts();
  convertText();
  replaceText();
  resizeContainers();

  window.addEventListener("resize", () => {
    resizeContainers();
  });

  buttons.forEach((btn, index) => {
    btn.addEventListener("click", () => {
      texts[index].classList.toggle("active");
      if (texts[index].classList.contains("active")) {
        texts[index].innerHTML = "<p>" + fullTexts[index] + "</p>";
        btn.innerText = "read less [-]";
      } else {
        setTimeout(() => {
          texts[index].innerHTML = "<p>" + convertedTexts[index] + "</p>";
          resizeContainer(texts[index]);
        }, 700);
        btn.innerText = "read more [+]";
      }
    });
  });
};

export default profileCards;
